import { SABox, SAButton, SAColumns, SAInput } from '@saux/design-system-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import insured_icon from '../../icons/Insured.png';
import claimSearch from '../../store/actions/claimsSearchActions';
import { capitalizeFirstLetter, isEmpty, isNotEmpty, simpleGTMDataLayer } from '../../utils/utilities';
import CheckBox from '../checkBox/CheckBox';
import "./AdvancedSearch.css";
import moment from 'moment';
import fetchConversations, { fetchConversationById } from '../../store/actions/conversationActions';
import { ADVANCED_SEARCH } from '../../utils/constants';



/**
 * Prop: input 1| input 2
 * Use : 
 * @returns: function | redner
 */
export default function AdvancedSearch(props: any) {

    const [searchValues, setSearchValues] = useState<any>({})
    const [claims, setClaims] = useState([])
    const [isFirstSearch, setFirstSearch] = useState(true);
    const [isIncludeClosedClaims, setIncludeClosedClaims] = useState(false);
    const user = useSelector((state: any) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: 'pageview',
            page: {
                path: '/search?advancedSearch=true',
                title: 'Claims Texting: Advanced Search Page'
            }
        });
    }, [])
    const getValue = (e: any, label: string) => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `${capitalizeFirstLetter(e.currentTarget.id)}-Input-Field-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Focussing on ${label} input field`,
            event_value: `${user.fullName} has focussed on ${label} field`
        });

        simpleGTMDataLayer({
            csrId: user.userName,
            event: `${capitalizeFirstLetter(e.currentTarget.id)}-Input-Field-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Focussing on ${label} input field`,
            event_value: `${user.fullName} has focussed on ${label} field`
        });
    };

    const handleChange = (e: any) => {
        setSearchValues({ ...searchValues, [e.target.name]: e.target.value })
    }

    const handleClosedClaims = (value: any) => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Closed-Claims-Checkbox-Click`,
            event_action: 'Checkbox Click',
            event_category: window.location.pathname,
            event_label: `User should select closed claims checkbox if they closed claims as well in simple search.`,
            event_value: `${user.fullName} has ${value ? "checked" : "unchecked"} the 'Include Closed Claims' checkbox.`
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Closed-Claims-Checkbox-Click-Snowplow`,
            event_action: 'Checkbox Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `User should select closed claims checkbox if they closed claims as well in simple search.`,
            event_value: `${user.fullName} has ${value ? "checked" : "unchecked"} the 'Include Closed Claims' checkbox.`
        });
        setIncludeClosedClaims(value);
    }

    const geFormattedSearchValues = () => {
        let query = "";
        for (const property in searchValues) {
            if (searchValues[property]) {
                query += `${property}: ${searchValues[property]},`;
            }
        }
        return query;
    }

    const getSearchFieldsWithDataNotEmpty = () => {
        let searchData = {};
        for (const property in searchValues) {
            let data = searchValues[property];
            if (data) {
                searchData = { ...searchData, [property]: data }
            }
        }
        if (!isIncludeClosedClaims) {
            searchData = { ...searchData, claim_status: "Open" }
        }
        return searchData;
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        let searchData = getSearchFieldsWithDataNotEmpty();
        if (isNotEmpty(searchData)) {
            //Snowplow tag for Advanced Search
            simpleGTMDataLayer({
                csrId: user.userName,
                event: `Contact-Search-Type-Click`,
                event_action: 'Button Click',
                event_category: window.location.pathname,
                event_label: `Selecting search type`,
                event_value: `${ ADVANCED_SEARCH}`
              });
              simpleGTMDataLayer({
                csrId: user.userName,
                event: `Contact-Search-Type-Click-Snowplow`,
                event_action: 'Button Click',
                event_category: window.location.pathname + "/Snowplow",
                event_label: `Selecting search type`,
                event_value: `${ADVANCED_SEARCH}`
              });

            //Snowplow tag to capture input details of Advanced Search  
            simpleGTMDataLayer({
            csrId: user.userName,
                event: `Search-Action-In-Advanced-Search`,
                event_action: 'Button Click',
                event_category: window.location.pathname,
                event_label: `This is for searching claims with given input fields`,
                event_value: `${user.fullName} has initiated advanced search with search values ${geFormattedSearchValues().slice(0, -1)}`
            });
            simpleGTMDataLayer({
            csrId: user.userName,
                event: `Search-Action-In-Advanced-Search-Snowplow`,
                event_action: 'Button Click',
                event_category: window.location.pathname + "/Snowplow",
                event_label: `This is for searching claims with given input fields`,
                event_value: `${user.fullName} has initiated advanced search with search values ${geFormattedSearchValues().slice(0, -1)}`
            });
            setFirstSearch(false);
            claimSearch(searchData)
                .then((res: any) => {
                    // let filterData: any = _.uniqBy(res.data.searchClaims, 'claim_number');
                    setClaims(res.data.searchClaims);
                })
                .catch(err => console.log(err))
        }
    }

    const handleSelect = (selectedItem: any) => {
        fetchConversationById({ claimNumber: selectedItem.claim_number, phoneNumber: selectedItem.claimant_phone_number }, user.email,
            (res: any) => {
                if (res && res.archiveStatus) {
                    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: true },
                        (res)=>{
                            props.createConversation(selectedItem);
                        }));
                }
                else {
                    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: false },
                        (res)=>{
                            props.createConversation(selectedItem);
                        }));
                }
            });
       // props.createConversation(selectedItem)

        // history("/profile/" + selectedItem._id)
    }

    const getMatchedItems = () => {
        return (<div style={{ height: "100%" }}>
            <div id="simple-search-header">
                <div style={{ margin: 20, marginLeft: 30 }}>
                    {`${claims.length} match(s)`}
                </div>
            </div>
            <div style={{ height: "60%", overflowY: "auto" }}>
                {claims.map((claim: any, index: any) => {
                    return (
                        <div className="simple-search-claims" key={index} onClick={() => handleSelect(claim)}>
                            <SAColumns key={claim._id} columns={{ sm: [4, 5, 3], xs: [12, 12, 12] }}>
                                <div>
                                    <SABox pb="small">
                                        <span style={{ fontSize: 16 }}>
                                            <b>
                                                {claim.first_name + " " + claim.last_name}
                                            </b>
                                        </span>
                                    </SABox>
                                    <SABox pb="small"><b>Claim Number:</b> {claim.claim_number}</SABox>
                                    <SABox >
                                        <b>Status: </b>
                                        {claim.claim_status}
                                    </SABox>
                                </div>
                                <div >
                                    <SABox pb="small"><b>Address:</b> {claim.claimant_address}</SABox>
                                    <SABox pb="small"><b>LOB:</b> {claim.lob}</SABox>
                                    <SABox><b>Care Professional:</b> {claim.care_professional}</SABox>
                                </div>
                                <div>
                                    <SABox pb="small"><b>Loss Date:</b> {moment(claim.loss_date || "").format(
                                        "MM-DD-YYYY")}</SABox>
                                    <SABox pb="small">
                                        <b>Phone Number: </b>
                                        {claim.claimant_phone_number || "N/A"}
                                    </SABox>
                                    <SABox ><b>Zip Code:</b> {claim.zip}</SABox>
                                </div>
                            </SAColumns>
                        </div>
                    )
                })
                }
            </div>
        </div>);
    }


    return (
        <div style={{ display: "flex", height: "100%" }}>
            <div className="simple-search-filter">
                <div style={{ margin: "10px 0px 0px 30px" }}>
                    <span style={{ fontSize: 24 }}>FILTERS</span>
                </div>
                <div style={{ maxHeight: "62%", overflow: "auto" }}>
                    <div className="simple-filter-input">
                        <SAInput
                            id="firstName"
                            name="first_name"
                            label="First Name"
                            type="text"
                            onChange={handleChange}
                            onFocus={(e) => getValue(e, "First Name")}
                        />
                    </div>
                    <div className="simple-filter-input">
                        <SAInput
                            id="lastName"
                            name="last_name"
                            label="Last Name"
                            type="text"
                            onChange={handleChange}
                            onFocus={(e) => getValue(e, "Last Name")}
                        />
                    </div>
                    <div className="simple-filter-input">
                        <SAInput
                            id="claimNumber"
                            name="claim_number"
                            label="Claim Number"
                            type="text"
                            onChange={handleChange}
                            onFocus={(e) => getValue(e, "Claim Number")}
                        />
                    </div>
                    <div style={{ "margin": "10px 0px 0px 30px" }}>
                        <SAInput
                            id="lossDate"
                            name="loss_date"
                            label="Loss Date"
                            type="date"
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            onFocus={(e) => getValue(e, "Loss Date")}
                        />
                    </div>
                    <div className="simple-filter-input">
                        <SAInput
                            id="zipCode"
                            name="zip"
                            label="ZIP Code"
                            type="text"
                            onChange={handleChange}
                            onFocus={(e) => getValue(e, "ZIP Code")}
                        />
                    </div>
                    <div className="simple-filter-input">
                        <CheckBox
                            id="isIncludeClosedClaims"
                            isChecked={searchValues["isIncludeClosedClaims"]}
                            handleChange={handleClosedClaims}
                            label="Include Closed Claims"
                            fontSize={20}
                        />
                    </div>
                    <div className="simple-filter-input">
                        <SAButton
                            fullWidth={false}
                            label="search"
                            onClick={handleSearch}
                            disabled={isEmpty(getSearchFieldsWithDataNotEmpty())}
                            textTransform="uppercase"
                            variant="primary"
                        />
                    </div>
                </div>

            </div>
            <div style={{ width: "80%" }}>
                {isFirstSearch ?
                    <div style={{ position: "absolute", top: "35%", left: "40%" }}>
                        <img src={insured_icon} alt="#" height={300} width={500} />
                    </div> : getMatchedItems()
                }
            </div>
        </div>
    )
}
